import { Button, Group, Paper, Select, Stack, Table } from '@mantine/core'
import { useForm } from '@mantine/form'
import { FormattedMessage, useIntl } from 'react-intl'
import { WorkspaceMemberRole } from '@/types/workspace'
import { useRoleDropdownOptions } from '../../useRoleDropdownOptions'

type FormValues = {
  role: string
}

export type SubmitValues = {
  role: WorkspaceMemberRole
}

type UpdateMemberFormProps = {
  name: string
  email: string
  role: WorkspaceMemberRole
  onCancel: () => void
  onUpdate: ({ role }: SubmitValues) => void
}

export const UpdateMemberForm = ({
  name,
  email,
  role,
  onCancel,
  onUpdate
}: UpdateMemberFormProps) => {
  const intl = useIntl()

  const workspaceMemberRoleOptions = useRoleDropdownOptions()

  const form = useForm<FormValues>({
    initialValues: {
      role: String(role)
    }
  })

  const handleUpdate = (formValues: FormValues) => {
    onUpdate({
      role: Number(formValues.role)
    })
  }

  return (
    <form onSubmit={form.onSubmit(handleUpdate)}>
      <Stack gap="xl">
        <Table variant="vertical" layout="fixed" withTableBorder>
          <Table.Tbody>
            <Table.Tr>
              <Table.Th w={160}>
                <FormattedMessage id="workspace.members.list.columns.name" />
              </Table.Th>

              <Table.Td>{name}</Table.Td>
            </Table.Tr>

            <Table.Tr>
              <Table.Th>
                <FormattedMessage id="workspace.members.list.columns.email" />
              </Table.Th>

              <Table.Td>{email}</Table.Td>
            </Table.Tr>
          </Table.Tbody>
        </Table>

        <Paper p="md" bg="gray.1">
          <Select
            {...form.getInputProps('role')}
            placeholder={intl.formatMessage({ id: 'workspace.members.role' })}
            data={workspaceMemberRoleOptions}
            label={intl.formatMessage({ id: 'workspace.members.role' })}
            autoFocus
          />
        </Paper>

        <Group justify="end">
          <Button miw={120} variant="default" onClick={onCancel}>
            <FormattedMessage id="cancel" />
          </Button>

          <Button miw={120} type="submit">
            <FormattedMessage id="workspace.members.update" />
          </Button>
        </Group>
      </Stack>
    </form>
  )
}
